import { ButtonBox } from '@defign/ui';
import classNames from './node_modules/.pnpm/classnames@2.5.1/node_modules/classnames/bind.mjs';
import style from './MssModal.module.mjs';
import { jsxs, jsx } from 'react/jsx-runtime';

const cx = classNames.bind(style);
function MssModal(_ref) {
  let {
    title,
    description,
    onButtonClick
  } = _ref;
  return /*#__PURE__*/jsxs("div", {
    className: cx('article'),
    children: [/*#__PURE__*/jsxs("div", {
      className: cx('modal-body'),
      children: [/*#__PURE__*/jsxs("div", {
        className: cx('modal-content'),
        children: [title && /*#__PURE__*/jsx("strong", {
          className: cx('title'),
          children: title
        }), description && /*#__PURE__*/jsx("p", {
          className: cx('description'),
          children: description
        })]
      }), /*#__PURE__*/jsx(ButtonBox, {
        text: "\uD655\uC778",
        onClick: onButtonClick,
        variant: "primary",
        color: "green",
        size: "large",
        isWide: true,
        disabled: false
      })]
    }), /*#__PURE__*/jsx("div", {
      className: cx('dimmed', 'show')
    })]
  });
}

export { MssModal };
